import React, { useContext, useEffect } from "react";
import { Button } from "~/foundation/Chakra";
import { useSitecoreContext } from "~/foundation/Jss";
import { Icon } from "../Icon";
import { ColorThemeContext } from "~/foundation/Theme/ColorThemeContext";

export const UserWay = () => {
	const { sitecoreContext } = useSitecoreContext();
	const [theme] = useContext(ColorThemeContext);

	const containerId = sitecoreContext.custom.settings.accessibilitySettings?.userWayCustomTriggerId || "accessibilityWidget";
	const isEnabled = sitecoreContext.custom.settings.accessibilitySettings?.userWayEnabled;
	const userWayScriptBlock = sitecoreContext?.custom?.settings?.accessibilitySettings?.userWayScriptBlock;

	if (!isEnabled || !userWayScriptBlock) {
		return null;
	}

	useEffect(() => {
		const script = document.createElement('script');
		script.innerHTML = userWayScriptBlock;
		const container = document.getElementById(containerId);
		container?.appendChild(script);

		return () => {
			container?.removeChild(script);
		}
	}, []);

	return (
		<Button
			id={containerId}
			variant="unstyled"
			aria-label="Click to open accessibility widget"
			display="flex"
			alignItems="center"
			justifyContent="center"
			ms={3}
			color={theme.colors.siteNavigation.color}
		>
			<Icon variant="UserWay" stroke="currentColor" fill="none" style={{ transition: "color 0.3s ease" }} />
		</Button>
	)
}